<template>
	<!-- 活动角标 -->
	<div class="sign-icon" v-if="isSign=='0'">
		<img  src="../../../static/sign-icon.png" class="_cpimg" alt="">
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default{
		name:'signicon',
		props:{
			isSign:{
				type:String,
				default:'1'
			}
		},
		watch:{
			isSign(val,old){
				console.log(val)
				console.log(old)
				
			}
		},
		data() {
			return {
				}
			
		},
		mounted(){
		},
		methods:{
			routeTask(){
			
			}
		}
	}
</script>

<style scoped>
	.sign-icon{
		position: fixed;
		right: 10px;
		bottom: calc(152px + constant(safe-area-inset-bottom));;
		bottom: calc(152px + env(safe-area-inset-bottom));;
	}
	.sign-icon>._cpimg{
		width: 70px;
		height: 70px;
	}
</style>



// WEBPACK FOOTER //
// src/view/components/sign-icon.vue